import { handleActions } from 'redux-actions'
import immutable from 'immutability-helper'
import { ActionTypes } from '../constants'

export const notifState = {
    status: 'idle',
    notifs: {
        data: [],
        meta: {
            total: 0,
            per_page: 0,
            current_page: 1,
            last_page: 1,
            first_page: 1,
            first_page_url: null,
            last_page_url: null,
            next_page_url: null,
            previous_page_url: null
        }
    },
    details: {
        unreadCount: 0,
        readCount: 0,
        total: 0
    },
    error: null
};


export default {
    notifications: handleActions(
        {
            // Reset semua notifikasi
            [ActionTypes.NOTIF_RESET]: (state) =>
                immutable(state, {
                    status: { $set: 'idle' },
                    notifs: {
                        $set: {
                            data: [],
                            meta: state.notifs.meta // pertahankan struktur meta
                        }
                    },
                    details: { $set: { unreadCount: null, readCount: null, total: 0 } },
                    error: { $set: null }
                }),


            [ActionTypes.NOTIF_FETCH]: (state) =>
                immutable(state, {
                    status: { $set: 'running' },
                }),

            [ActionTypes.NOTIF_MARK_READ_ALL]: (state) =>
                immutable(state, {
                    status: { $set: 'running' },
                }),

            [ActionTypes.NOTIF_MARK_READ]: (state) =>
                immutable(state, {
                    status: { $set: 'running' },
                }),

            [ActionTypes.NOTIF_MARK_UNREAD]: (state) =>
                immutable(state, {
                    status: { $set: 'running' },
                }),

            [ActionTypes.NOTIF_TOGGLE_IMPORTANT]: (state) =>
                immutable(state, {
                    status: { $set: 'running' },
                }),

            // Fetch sukses
            [ActionTypes.NOTIF_FETCH_SUCCESS]: (state, { payload }) =>
                immutable(state, {
                    status: { $set: 'success' },
                    notifs: { $set: payload.notifs },
                    details: { $set: payload.details },
                    error: { $set: null }
                }),

            // Fetch gagal
            [ActionTypes.NOTIF_FETCH_FAILED]: (state, { payload }) =>
                immutable(state, {
                    status: { $set: 'error' },
                    error: { $set: payload },
                }),

            // Push dari WebSocket
            [ActionTypes.NOTIF_WS_PUSH]: (state, { payload }) => {
                console.log(state)
                console.log(payload)

                const content_data = state.notifs?.data || []
                const exists = content_data.find(n => n.id === payload.id)
                if (exists) return state

                const newDetails = {
                    ...state.details,
                    total: state.details.total + 1,
                    unreadCount: (state.details.unreadCount ?? 0) + 1
                }

                return immutable(state, {
                    status: { $set: 'success' },
                    notifs: {
                        data: { $unshift: [payload] }   // **PERBAIKAN DI SINI**
                    },
                    details: { $set: newDetails }
                })
            },

            // Mark as read
            [ActionTypes.NOTIF_MARK_READ]: (state, { payload }) => {
                const idx = state.notifs.findIndex(n => n.id === payload)
                if (idx === -1) return state

                const wasUnread = !state.notifs[idx].read
                const newDetails = wasUnread
                    ? { ...state.details, unreadCount: (state.details.unreadCount ?? 1) - 1, readCount: (state.details.readCount ?? 0) + 1 }
                    : state.details

                return immutable(state, {
                    status: { $set: 'success' },
                    notifs: { [idx]: { read: { $set: true } } },
                    details: { $set: newDetails }
                })
            },

            // Mark as unread
            [ActionTypes.NOTIF_MARK_UNREAD]: (state, { payload }) => {
                const idx = state.notifs.findIndex(n => n.id === payload)
                if (idx === -1) return state

                const wasRead = state.notifs[idx].read
                const newDetails = wasRead
                    ? { ...state.details, unreadCount: (state.details.unreadCount ?? 0) + 1, readCount: (state.details.readCount ?? 1) - 1 }
                    : state.details

                return immutable(state, {
                    status: { $set: 'success' },
                    notifs: { [idx]: { read: { $set: false } } },
                    details: { $set: newDetails }
                })
            },

            // Toggle important
            [ActionTypes.NOTIF_TOGGLE_IMPORTANT]: (state, { payload }) => {
                const idx = state.notifs.findIndex(n => n.id === payload)
                if (idx === -1) return state

                const current = state.notifs[idx].important ?? false

                return immutable(state, {
                    status: { $set: 'success' },
                    notifs: { [idx]: { important: { $set: !current } } }
                })
            },

            // Clear all
            [ActionTypes.NOTIF_CLEAR]: (state) =>
                immutable(state, {
                    status: { $set: 'success' },
                    notifs: { $set: [] },
                    details: { $set: { unreadCount: 0, readCount: 0, total: 0 } }
                }),
        },
        notifState
    ),

}
